module.exports = (__webpack_require__(7272))(800);